"use client"
import type React from "react"
import {
  type LineClampVariantProps,
  lineClampVariants,
} from "../../styles/utils/lineclamp"
import { classNames } from "../../utils"
import { Block, type BlockProps } from "../Block"

export type TruncateProps = {
  children: React.ReactNode
  className?: string
  onOverflowedChange?: (overflowed: boolean) => void
} & LineClampVariantProps &
  BlockProps

export function Truncate({ className, lines, ...rest }: TruncateProps) {
  return (
    <Block
      className={classNames(
        "max-w-full",
        !lines && "truncate",
        lineClampVariants({ lines }),
        className,
      )}
      {...rest}
    />
  )
}
